import { setSnackState } from '../../../../actions';
import { notificationDispatchUtil } from '../../../../utils/dispatchUtil';
import i18n from '../../../../i18n';

export const passkeysSnackUtil = {
  passkeyAlreadyRegistered: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:passkeyAlreadyRegistered'),
      }),
    );
  },
  passkeyRegistrationFailed: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:passkeyRegistrationFailed'),
      }),
    );
  },
  passkeyVerificationFailed: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:passkeyVerificationFailed'),
      }),
    );
  },
  passkeyPartialSupportFailed: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:passkeyPartialSupportFailed'),
      }),
    );
  },
  noPasskeysAvailable: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:noPasskeysAvailable'),
      }),
    );
  },
  deleteUserPasskeySuccess: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('passkeys:deleteUserPasskeySuccess'),
        severity: 'success',
      }),
    );
  },
};
